<br>
<div class="group-label mb-3">
  <p class="ps">{{variables.selectOrAddTechnology}}.</p>
</div>

@if (isLoading && !errorDetected) {
<app-loader class="centerLoader"></app-loader>
}

<mat-form-field class='catalog-search-field' appearance="outline">
  <input matInput placeholder="{{variables.search}}..." search (keyup)="onSearchCatalog($event)" />
</mat-form-field>

<div [formGroup]="subForm">
  @if (!isLoading && !errorDetected) {
  <mat-radio-group formControlName="firstCtrl">
    <div class="radio-group-control">
      <div>
        @for (item of filterCatalogs; track item) {
        <div class="radio-group-control-item" [class.selected-catalog]="subForm.get('firstCtrl')?.value === item.id"
          [attr.id]="'catalog-item-' + item.id">
          <div class="row">
            <div class="col-6">
              <mat-radio-button class="radio-group-control-item-button"
                [value]="item.id" (click)="onRadioClick($event, item.id)">{{item.name}}</mat-radio-button>
            </div>
            <div class="col-6">
              <div class="action_buttons">
                @if (!item.active) {
                <span class="warning-icon action_buttons-item" matTooltip="{{variables.incompleteCatalog}}" matTooltipPosition="left">
                  <mat-icon svgIcon="Danger" style="width:25px; height:25px;"></mat-icon>
                </span>
                } @else {
                <span class="action_buttons-item action_buttons-placeholder"></span>
                }
                <!-- Edit button: shown only if user has permission AND backend says they can edit (SUPER_ADMIN or owner) -->
                <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" 
                      [showWhen]="item.owner" 
                      (click)="openDialogEditName(item.id, item.state)" class="icon-edit action_buttons-item"
                      matTooltip="{{variables.editCatalog}}">
                  <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
                </span>
                <!-- Placeholder when user cannot edit -->
                <span [showWhen]="!item.owner || !(Permission.CATALOG_EDIT_CONFIG | hasPermission)"
                      class="action_buttons-item action_buttons-placeholder"></span>                
                <!-- Delete button: shown only if user has permission AND backend says they can edit (SUPER_ADMIN or owner) -->
                <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" 
                      [showWhen]="item.owner" 
                      (click)="openDialogRemove(item)" class="icon-close action_buttons-item"
                      matTooltip="{{variables.removeCatalog}}">
                  <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
                </span>
                <!-- Placeholder when user cannot delete -->
                <span [showWhen]="!item.owner || !(Permission.CATALOG_EDIT_CONFIG | hasPermission)"
                      class="action_buttons-item action_buttons-placeholder"></span>                
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </mat-radio-group>
  <mat-paginator class="catalog-paginator" [length]="totalElements"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [hidePageSize]="true"
    (page)="onPageChange($event)">
  </mat-paginator>
  }

  <br>
  @if (!isLoading && !errorDetected) {
  <div class="d-flex" style="max-width: 60%;">
    <!--@if ((authService.isAdmin() | async)) {-->
    <app-button *hasPermission="Permission.CATALOG_MANAGE" typeBtn="primary" (click)="openDialog()" message="{{variables.addNewCatalog}}"></app-button>
    <!--}-->
    @if (isSelected) {
    <app-button typeBtn="secondary" class="ml-auto" (click)="next()" message="{{variables.next}}"></app-button>
    }
  </div>
  }
</div>